export default `6.9.15${process.env.NODE_ENV === "development" ? "-dev" : ""}`;
